/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-cond-assign */
/* eslint-disable react/self-closing-comp */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { h } from 'preact';
import styled from 'styled-px2rem';
import './style.css';
import { observer } from 'mobx-react';
import { useEffect, useRef, useState } from 'preact/hooks';
import { Tabs, Toast } from 'antd-mobile';
import SearchWrap from '../extension/component/SearchWrap';
import List from './component/List';
import EmptoyList from '../extension/component/EmptoyList';
import UM from '../../utils/UM';
import CopyText from 'react-copy-text';
import TabWrap from './component/TabWrap';
import { animate } from 'popmotion';
import { route } from 'preact-router';

let TimeObj: any = null;

const Extension: any = ({ store }: { store: any }) => {
  useEffect(() => {
    document.title = '商品搜索';
    UM({
      page: '商品搜索',
      label: '商品搜索页访问',
      event: '商品搜索页访问',
    });
    const Search = new window.URLSearchParams(window.location.search);
    const key = Search.get('keyword') || '';
    store.scene = Search.get('listtype') || store.scene;
    if (Search.get('listtype')) {
      store.requestFirst = false;
    }
    store.searchKeywords = key;
    store.getSearchList();
  }, []);
  const refreshData = () => {
    store.searchList = [];
    store.searchCategoryListNew = [];
    store.todayCategoryId = '';
    window.scrollTo(0, 0);

    const params = new URLSearchParams(new URL(window.location.href).search);
    params.set('keyword', store.searchKeywords);
    route(`${new URL(window.location.href).pathname}?${params.toString()}`);

    store.getSearchList();
  };
  return (
    <Container className={'pt-192'}>
      <CopyText text={store.liveCopyText} />
      <TopWrap>
        <SearchWrap
          keywords={store.searchKeywords}
          handleSearch={() => {
            if (!store.searchKeywords) {
              Toast.show({ content: '亲，输入商品名称试试！' });
              return;
            }
            store.liveSearchFlag = store.scene == 'live';
            refreshData();
          }}
          searchInputTextChange={store.searchInputChange}
        />
        <TabWrap
          list={store.searchCategoryListNew}
          todayCategoryId={store.todayCategoryId}
          handelCategoryId={(id: any) => {
            if (id == store.todayCategoryId) {
              return;
            }
            if (id == 'back') {
              store.liveSearchFlag = false;
              store.searchKeywords = '';
              const params = new URLSearchParams(
                new URL(window.location.href).search,
              );
              params.delete('keyword');
              params.set('listtype', store.scene);
              window.scrollTo(0, 0);
              route(`/legacy?${params.toString()}`);
              return;
            }
            store.todayCategoryId = id;
            const domObj: any = document.getElementById(`title-${id}`);
            store.liveScrollFlag = false;
            if (TimeObj) {
              clearTimeout(TimeObj);
              TimeObj = null;
            }
            TimeObj = setTimeout(() => {
              store.liveScrollFlag = true;
            }, 2000);
            setTimeout(() => {
              animate({
                from: window.scrollY, // 当前的位置
                to: domObj.offsetTop - 240, // 目标位置
                onUpdate: (latest) => window.scrollTo(0, latest),
              });
            }, 10);
          }}
        />
      </TopWrap>
      {store.searchList.length > 0 && (
        <List
          searchCategoryList={store.searchCategoryListNew}
          list={store.searchList}
          cateList={store.searchCategoryListNew}
          handelCategoryId={(id: any) => {
            if (store.liveScrollFlag) {
              store.todayCategoryId = id;
            }
          }}
          scene={store.scene}
          liveFlatFlag={true}
          handleMoreData={() => {
            store.getLiveList();
          }}
          setItem={(item: any) => {
            store.hanleJumpLive(item);
            UM({
              page: '直播页',
              label: '直播页商品点击',
              event: '直播页商品点击',
              value: {
                title: item.title,
                productId: item.item_id,
                categoryId: item.categoryId || '0',
                scene: store.scene,
              },
            });
          }}
        />
      )}
      {store.firstLoading && (
        <EmptoyList loading={store.searchLoading} list={store.searchList} />
      )}
    </Container>
  );
};
export default observer(Extension);
const Container = styled.div`
  width: 100%;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  align-items: center;
  background: #efeef4;
  padding-bottom: 56px;
`;
const TopWrap = styled.div`
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #efeef4;
  z-index: 1000;
`;
